  import { Injectable, NgZone } from '@angular/core';
  import { Subject } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { environment } from 'environments/environment';
import { UserService } from '../user/user.service';

/** `{{vittoria}}/v1/notifications` */
const notificationApiUrl: string = environment.VITTORIA_BACKEND_URL + environment.NOTIFICATIONS_BACKEND_URL;
  
  @Injectable({
    providedIn: 'root'
  })
  export class SseService {
    private eventStream = new Subject<any>();
    private eventSource: EventSource | null = null;
    private lastId: number = 0;
  
    constructor(private _ngZone: NgZone, private authService: AuthService,private userService:UserService) {}
  
    connect() {
      this.closeConnection(); // Chiudi eventuale connessione esistente
      const userData = this.userService.userData
      const userRole = userData
      ? userData.idRole
      : 4;

      const userId = userData
      ? userData.idUser
      : 1;

      const groupId = userData
      ? userData.idGroup
      : null;

      let url = `${notificationApiUrl}?&idUser=${userId}&idRole=${userRole}&idGroup=${groupId}&lastId=${this.lastId}`;
      this.eventSource = new EventSource(url);
      // console.log("Mi connetto al server");
      
      this.eventSource.addEventListener("notification", (event) => {
        this._ngZone.run(() => {
          try {
            const parsedData = JSON.parse(event.data);
            this.eventStream.next(parsedData);
            
            // Trova il massimo id tra quelli ricevuti
            const maxId = Math.max(...parsedData.map((item: any) => item.idActiveEvent), this.lastId);
            this.lastId = maxId; // Aggiorna lastId
          } catch (error) {
            console.error("Errore nel parsing SSE:", error);
          }
        });
      });
  
      this.eventSource.onerror = (error) => {
        console.error("Errore SSE:", error);
        this.closeConnection();
      };
    }
  
    listenForNotifications(callback: (data: any[]) => void) {
      this.eventStream.subscribe(callback);
    }
  
    private closeConnection() {
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
    }
  }

 